import DataGrid2 from '../../..';

export function getSelectedRows(this: DataGrid2) {
	return this.rows.filter(i => i.selected);
}
